import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";

export default function CurrentCoinTable({row}) {
  console.log(row);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Name</TableCell>
            <TableCell align="right">Current Price</TableCell>
            <TableCell align="right">Symbol</TableCell>
            <TableCell align="right">24h Price change percentage</TableCell>
            {/* <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            key={row.name}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <TableCell component="th" scope="row">
              {row?.name}
            </TableCell>
            <TableCell align="right">{row?.current_price}</TableCell>
            <TableCell align="right">{row?.symbol}</TableCell>
            <TableCell align="right">{row?.price_change_percentage_24h}</TableCell>
            {/* <TableCell align="right">{row.protein}</TableCell> */}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
